<script>
/* Imports */
    import BlokNacitani from './../BlokNacitani.svelte';
    import DateInput from "./TerminovyKalendar/DateInput.svelte";
    import KalendarHeader from "./TerminovyKalendar/KalendarHeader.svelte";
    import KalendarMesic from "./TerminovyKalendar/KalendarMesic.svelte";
    import { APIrequestGET } from '../js_libs/API_calls';

/* Props */
    export let VybraneRezervaceZakaznika = [];
    export let ChybovyVyber = false; 

/* Vlastnosti */
    // Vybírané datumy pro začátek a konec rezervací
    let VybranePocatecniDatum = new Date(new Date().setDate(new Date().getDate() + 1));
    let VybraneKoncoveDatum = new Date(new Date().setDate(new Date().getDate() + 1));   

    // Dovoluje měsícům mezi sebou komunikovat o momentálním typu vybíraného data uživatelem
    let PrepinacVyberuData = 0;


    // Zobrazení uživatele
    let PocetZobrazovanychMesicu = 3;
    let PocatecniDatumZobrazeni = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
    
    
    // Údržba dostupných rezervací v paměti 
    let PocetMesicuVPameti = PocetZobrazovanychMesicu;
    let PocatecniDatumDat = PocatecniDatumZobrazeni;
    $: KonecneDatumDat = ZiskatKonecneDatumDatVPameti(PocetMesicuVPameti);
    
    
    let AktualniZiskaneRezervacniTerminy = [];
    
    $: PocatekZobrazovanychMesicu = (PocatecniDatumZobrazeni) =>
    {
        
        return PocatecniDatumZobrazeni.getMonth() - PocatecniDatumDat.getMonth() + ((PocatecniDatumZobrazeni.getFullYear() - PocatecniDatumDat.getFullYear()) * 12);
    }

    $: KonecZobrazovanychMesicu = (PocatecniDatumZobrazeni) =>
    {
        return PocatecniDatumZobrazeni.getMonth() - PocatecniDatumDat.getMonth() + ((PocatecniDatumZobrazeni.getFullYear() - PocatecniDatumDat.getFullYear()) * 12) + PocetZobrazovanychMesicu;
    }
/* Funkce */

    /**
     * 
     */
    function AktualizujUzivateluvVyber()
    {
        // console.log("POC", VybranePocatecniDatum);
        // console.log("END", VybraneKoncoveDatum);

        let filtrovanePrvky = AktualniZiskaneRezervacniTerminy.filter(prvek => 
        {
            const start = new Date(prvek.start_time).getTime();
            // console.log("STR", new Date(prvek.start_time));
            return (start >= VybranePocatecniDatum.getTime() && start <= VybraneKoncoveDatum.getTime()) || (JsouDataStejna(new Date(start), VybranePocatecniDatum));
        });

        let errorable = filtrovanePrvky.some(prvek => prvek.reserved === prvek.capacity) || VybranePocatecniDatum.getTime() < (new Date().getTime()) || VybraneKoncoveDatum.getTime() < (new Date().getTime());
        if (errorable)
        {
            VybraneRezervaceZakaznika = [];
            ChybovyVyber = true;
        }
        else 
        {
            VybraneRezervaceZakaznika = filtrovanePrvky;
            ChybovyVyber = false;
        }
    }

    /**
     * Získá konečné datum, pro stažení ze serveru.
     * 
     * @param {Number} rozsah - počet měsíců v řadě po datu zobrazení.
     */
    function ZiskatKonecneDatumDatVPameti(rozsah) 
    {
        const pocatek = PocatecniDatumDat;

        return new Date(pocatek.getFullYear(), pocatek.getMonth() + rozsah, 0);
    }

    /**
     * Vybere měsíce pro zobrazení v kalendáři
     * 
     * @param ZobrazovanyMesic (Date) - počáteční datum zobrazení kalendáře
     * @param PocetMesicu (Number) - počet měsíců, které se mají zobrazit od počátečního data
     * @returns {Array<Array>} - pole měsíců, které se mají zobrazit - pole obsahuje pouze prvky Date prvního dne daného měsíce
     */
    function ZiskatMesice(RezervacniTerminy) {
        // Zápis dat pro vybírané funkce
        AktualniZiskaneRezervacniTerminy = RezervacniTerminy;

        const mesiceMapa = new Map();

        RezervacniTerminy.forEach(termin => {
            const datum = new Date(termin.start_time);
            const klic = `${datum.getFullYear()}-${datum.getMonth()}`; // např. "2025-5"

            if (!mesiceMapa.has(klic)) {
                mesiceMapa.set(klic, []);
            }

            mesiceMapa.get(klic).push(termin);
        });

        // Seřadit podle roku a měsíce
        const serazene = Array.from(mesiceMapa.entries()).sort(([a], [b]) => {
            const [rokA, mesicA] = a.split('-').map(Number);
            const [rokB, mesicB] = b.split('-').map(Number);
            return rokA !== rokB ? rokA - rokB : mesicA - mesicB;
        });

        // console.log(serazene.map(([_, terminy]) => terminy));

        // Vrátit jen pole s termíny
        return serazene.map(([_, terminy]) => terminy);
    }


    /**
     * @description Formátuje datum pro API v požadovaném formátu DD-MM-YYYY
     * 
     * @param {Date} datum - Datum, které se má formátovat pro API
     * 
     * @returns {String} - Formátované datum ve tvaru DD-MM-YYYY
     */
    function FormatovatDatumProAPI(datum) 
    {
        const dd = String(datum.getDate()).padStart(2, '0');
        const mm = String(datum.getMonth() + 1).padStart(2, '0');
        const yyyy = datum.getFullYear();
        const final = `${yyyy}-${mm}-${dd}`;
        // console.log("Formátované datum pro API:", final);

        return final;
    }

    /**
     * Získá informace o kapacitách, termínech ze serveru.
     * 
     * @param prvniDen - Počátek výběru termínů k rezervaci
     * @param posledniDen - Konec výběru termínů k rezervaci
     * 
     * @return {Promise<Object>} s možnými termíny rezervace pro daný měsíc
     */
    async function ZiskatTerminyRezervaci(prvniDen, posledniDen)
    {
        const PrvniDen = new Date(prvniDen.getFullYear(), prvniDen.getMonth(), prvniDen.getDate());
        const PosledniDen = new Date(posledniDen.getFullYear(), posledniDen.getMonth(), posledniDen.getDate());

        return JSON.parse(await APIrequestGET(
            "available",
            {
                "res_place_uuid" : "hraza",
                "dateFrom" : FormatovatDatumProAPI(PrvniDen),
                "dateTo" : FormatovatDatumProAPI(PosledniDen)
            }
        ))
    }

    /**
     * @description Funkce vypočítá, zda je rok, měsíc a den u obou datumů stejný
     * 
     * @param {Date} date1 - první datum k porovnání
     * @param {Date} date2 - druhé datum k porovnání
     * 
     * @returns {Bool} true, pokud je rok, měsíc a den stejný u dvou dat
     */
    function JsouDataStejna(date1, date2) 
    {
        return date1.getFullYear() === date2.getFullYear() &&
            date1.getMonth() === date2.getMonth() &&
            date1.getDate() === date2.getDate();
    }
</script>

<div 
    class="terminovy-kalendar"
    style="width: 100%; display: flex; flex-direction: column; align-items: center;"
    >

    <label style="width: 100%; text-align: center;" for="kalendar-od-do">Vyberte termín pobytu (od - do)</label>
    
    <div class="kalendar-od-do" name="kalendar-od-do">
        <div class="kalendar-inputs">
            <DateInput 
                id="pocatecni-datum"
                labelTitle="Od:"
                required={true}
                bind:date={VybranePocatecniDatum}
                on:change={() => {
                    if(VybranePocatecniDatum.getTime() > KonecneDatumDat.getTime())
                    {
                        KonecneDatumDat = new Date(VybranePocatecniDatum.getFullYear(), VybranePocatecniDatum.getMonth() + 1, 0);
                    }

                    AktualizujUzivateluvVyber();
                }}
            />
            
            <DateInput 
                id="koncove-datum"
                labelTitle="Do:"
                required={true}
                bind:date={VybraneKoncoveDatum}
                on:change={() => {
                    if(VybraneKoncoveDatum.getTime() > KonecneDatumDat.getTime())
                    {
                        KonecneDatumDat = new Date(VybraneKoncoveDatum.getFullYear(), VybraneKoncoveDatum.getMonth() + 1, 0);
                    }

                    if(!JsouDataStejna(VybranePocatecniDatum, VybraneKoncoveDatum))
                        AktualizujUzivateluvVyber();
                }}
            />
        </div>
        <KalendarHeader
            bind:PocatecniDatumZobrazeni
            bind:PocetZobrazovanychMesicu
            on:posunMesiceVpred={()=>
                {
                    if(KonecZobrazovanychMesicu(PocatecniDatumZobrazeni) > PocetMesicuVPameti)
                    {
                        PocetMesicuVPameti++;
                    }
                }
            }
            />
        <div class="kalendar-mesice">
            {#await ZiskatTerminyRezervaci(PocatecniDatumDat, KonecneDatumDat)}
                <BlokNacitani height={"295px"} />
            {:then terminy} 
                {#each ZiskatMesice(terminy) as mesic, i}
                    <KalendarMesic
                        TerminyProDanyMesic={mesic}
                        bind:VybranePocatecniDatum
                        bind:VybraneKoncoveDatum
                        bind:PrepinacVyberuData
                        displayed={i >= PocatekZobrazovanychMesicu(PocatecniDatumZobrazeni) && i < KonecZobrazovanychMesicu(PocatecniDatumZobrazeni)}
                        on:change={() => {
                            // AktualizujUzivateluvVyber();
                            //displayed={i >= PocetMesicuVPameti - PocetZobrazovanychMesicu && i < PocetMesicuVPameti}
                        }}
                        />
                {/each}
                
            {/await}
        </div>
    </div>
</div>  



<style>
    .kalendar-od-do 
    {
        max-width: 900px;
        margin: 0 auto;
        font-family: Arial, sans-serif;
        width: 100%;
    }
    .kalendar-inputs
    {
        display: flex;
        gap: 2em;
        margin: 1em 0 1em 0;
        justify-content: space-evenly;
    }
    .kalendar-mesice 
    {
        display: flex;
        gap: 2em;
    }
</style>